/**
 * The Service reminders route (SWOOP-281). Shared by the route's `beforeLoad` and the page's `<ModuleGate>`,
 * which both look its owning module up in the registry (`moduleAreaForPath`) rather than naming it.
 */
export const SERVICE_REMINDERS_PATH = '/reminders';

/** The permission that lets a user see the reminders queue, the page and the sidebar badge. */
export const SERVICE_REMINDERS_VIEW_PERMISSION = 'service-plans:list';

/** The permission that lets a user act on a reminder: snooze it (and later dismiss it). */
export const SERVICE_REMINDERS_MANAGE_PERMISSION = 'service-plans:manage';
